import React from "react";
import { Image, StyleSheet } from '@react-pdf/renderer';
import QRCode from 'qrcode';


const styles = StyleSheet.create({
  image: {
    position: 'absolute',
    height: '80px',
    width: '80px',
  },
});

const QRGenerator = ({ qrCodeData }) => {
  const qrCodeOptions = {
    width: 100, // Adjust the size of the QR code as needed
  };
  const qrCodeDataURL = QRCode.toDataURL(qrCodeData, qrCodeOptions);
  return (
    <Image style={styles.image} src={qrCodeDataURL} ></Image>
  );
};
export default QRGenerator;
